import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import ProductLoop from "../pages/site/ProductLoop";

export default function AuthShell({ title, subtitle, children, footer, testid }) {
  return (
    <div className="flex min-h-screen bg-app text-ink">
      <div className="site relative hidden w-[48%] flex-col justify-between overflow-hidden p-10 lg:flex xl:p-14">
        <div className="site-grid site-grid-fade absolute inset-0" />
        <Link to="/" className="relative flex items-center gap-2.5" data-testid="auth-logo"><img src="/logo.webp" alt="TRAIDE" className="h-9 w-auto" /></Link>
        <div className="relative">
          <div className="font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-amber-500">The operating system for trade businesses</div>
          <h2 className="display mt-3 text-3xl font-extrabold uppercase leading-[1.02] text-white xl:text-4xl">Run your entire trade business from one place.</h2>
          <div className="mt-8 max-w-xl"><ProductLoop compact interval={3000} /></div>
        </div>
        <div className="relative flex items-center justify-between text-[12px] text-zinc-500"><span>Admin · Staff · Client — one connected platform</span><span className="flex items-center gap-1.5"><ShieldCheck size={13} className="text-emerald-500" /> Secure sign-in</span></div>
      </div>
      <div className="flex flex-1 items-center justify-center px-4 py-10">
        <div className="w-full max-w-md animate-in" data-testid={testid}>
          <Link to="/" className="mb-8 flex items-center gap-2.5 lg:hidden"><img src="/logo.webp" alt="TRAIDE" className="h-9 w-auto" /></Link>
          <h1 className="h1 !text-2xl sm:!text-3xl">{title}</h1>
          {subtitle && <p className="t3 mt-1.5 text-sm">{subtitle}</p>}
          <div className="card mt-6 p-6">{children}</div>
          {footer && <div className="t3 mt-5 text-center text-sm">{footer}</div>}
          <div className="t4 mt-8 flex items-center justify-center gap-4 text-[12px]"><Link to="/" className="hover:underline" data-testid="auth-back-home">← traide.com</Link><Link to="/book-demo" className="hover:underline">Book a demo</Link><Link to="/pricing" className="hover:underline">Pricing</Link></div>
        </div>
      </div>
    </div>
  );
}
